import { ComponentSelector, ComponentInjector } from '@atypon/ui-utils';
import PhotoQuickSearch, {
    PhotoQuickSearchElements,
    PhotoQuickSearchSelectors,
    PhotoQuickSearchTexts,
    PhotoQuickSearchClassList
} from 'ui-theme/widgets/quick-search/js/quick-search';

class Texts extends PhotoQuickSearchTexts { }

class ClassList extends PhotoQuickSearchClassList { }

class Selectors extends PhotoQuickSearchSelectors {
    qucikSearchField = new ComponentSelector('input', '.autoComplete_wrapper');
}

class Elements extends PhotoQuickSearchElements {
    qucikSearchField: HTMLInputElement;

}

interface QuickSearch {
    get elements(): Elements;
    get texts(): Texts;
    get classList(): ClassList;
    get selectors(): Selectors;
}
class QuickSearchElm {
    constructor(public el: HTMLInputElement, public searchType: string, public seriesKey: string) { }
}
@ComponentInjector(Selectors, Elements, ClassList, Texts)
class QuickSearch extends PhotoQuickSearch {

    protected get defaultConfigs () {
        return {
            maxResults: 10,
            threshold: 2,
            debounce: 300,
            resultItem: {
                element: this.elementRenderer.bind(this),
                class: 'autoComplete__item'
            },
            searchEngine: (query, record) => {
                return record.highlight || record.label;
            },
        }
    }
}

export default QuickSearch;